'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _loginComponent = require('./login-component');

var _loginComponent2 = _interopRequireDefault(_loginComponent);

var _actions = require('./actions');

var _selectors = require('../selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    casData: _selectors.getCasData,
    isFetching: _selectors.isFetching,
    componentMethodToCall: _selectors.getComponentMethodToCall,
    title: _selectors.getMessageTitle,
    text: _selectors.getMessageText,
    placeholders: _selectors.getMessagePlaceholders
});


var mapDispatchToProps = {
    initForm: _actions.initForm,
    clearProps: _actions.clearProps,
    registrationClicked: _actions.registrationClicked,
    trackingEvent: _actions.trackingEvent
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_loginComponent2.default);
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-component/Container.js
// module id = 485
// module chunks = 0